import { useFormContext } from 'react-hook-form'

type Props = {
  isActive: boolean
  option: Option
  name: string
}

type Option = {
  label: string
  value: string
}

export const RadioField = ({ isActive, option, name }: Props) => {
  const { register } = useFormContext()
  return (
    <label
      className={`flex items-center justify-center w-full border rounded-lg py-4 cursor-pointer transition-all ${
        isActive ? 'border-black' : 'border-gray-300 hover:border-gray-400'
      }`}
      key={option.value}
    >
      <input type="radio" value={option.value} {...register(name)} className="hidden" />
      <div className="flex items-center gap-2">
        <span
          className={`w-4 h-4 rounded-full border flex items-center justify-center ${
            isActive ? 'border-primary' : 'border-gray-400'
          }`}
        >
          {isActive && <span className="w-2.5 h-2.5 bg-primary rounded-full" />}
        </span>
        <span className="text-base text-gray-800">{option.label}</span>
      </div>
    </label>
  )
}
